Bingo.NumberCounter = {};

Bingo.NumberCounter.init = ($input) => {
    const wrap = $input.closest('.js-numberCounter');
    const getValues = (target) => {
        const values = {
            minValue: parseInt(target.attr('min')),
            maxValue: parseInt(target.attr('max')),
            currentValue: parseInt(target.val()),
            name: target.attr('name'),
        };
        return values;
    };
    const getControls = () => {
        const controls = {
            minus: wrap.find(".js-numberCounter__button[data-type='minus']"),
            plus: wrap.find(".js-numberCounter__button[data-type='plus']"),
        };
        return controls;
    };
    const resizeInput = () => {
        $input.css('width', `${$input.val().length * 8 + 22}px`);
    };
    const checkLimitValues = (input, values) => {
        const controls = getControls();
        if (values.currentValue === values.minValue) {
            controls.minus.attr('disabled', true);
        } else if (values.currentValue > values.minValue) {
            controls.minus.removeAttr('disabled');
        } else {
            $input.val($input.data('old-value'));
        }
        if (values.currentValue === values.maxValue) {
            controls.plus.attr('disabled', true);
        } else if (values.currentValue < values.maxValue) {
            controls.plus.removeAttr('disabled');
        } else {
            $input.val($input.data('old-value'));
        }
    };
    const controls = wrap.find('.js-numberCounter__button');
    const values = getValues($input);
    checkLimitValues($input, values);
    resizeInput();

    controls.on('click', (e) => {
        e.preventDefault();
        const type = $(e.currentTarget).attr('data-type');
        const currentValue = parseInt($input.val());
        let step = 1;
        if ($input.attr('data-step') !== undefined) {
            step = parseInt($input.attr('data-step'));
        }
        if (!Number.isNaN(currentValue)) {
            if (type === 'minus' && currentValue > $input.attr('min')) {
                if ((currentValue - step) < $input.attr('min')) {
                    $input.val(parseInt($input.attr('min'))).change();
                } else {
                    $input.val(currentValue - step).change();
                }
            } else if (type === 'plus' && currentValue < $input.attr('max')) {
                if ((currentValue + step) > $input.attr('max')) {
                    $input.val(parseInt($input.attr('max'))).change();
                } else {
                    $input.val(currentValue + step).change();
                }
            }
        }
    });

    $input.focusin(() => {
        $input.data('old-value', $input.val());
    });
    $input.change(() => {
        checkLimitValues($input, getValues($input));
        resizeInput();
    });
};

(function ($) {
    $.nette.ext('bingo-number-counter', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                // $el is new html in dom, so initialize NumberCounter only in this new html part.
                self.init($el);
            }, this));

            // On page load initialize all NumberCounters present in body.
            self.init($('body'));
        },
    }, {
        init($el) {
            $el.find('.js-numberCounter__input').each(function () {
                Bingo.NumberCounter.init($(this));
            });
        },
    });
}(jQuery));
